/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		2: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "thunder." + ({"0":"prizelist"}[chunkId]||chunkId) + ".min.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "http://img.vip.kanimg.com/lib/thunderjs/1.5.0m/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 79);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = Zepto;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(4);
var createDesc = __webpack_require__(13);
module.exports = __webpack_require__(5) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(33);
var toPrimitive = __webpack_require__(20);
var dP = Object.defineProperty;

exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(12)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(52);
var defined = __webpack_require__(18);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(24)('wks');
var uid = __webpack_require__(14);
var Symbol = __webpack_require__(1).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(30);

var _typeof3 = _interopRequireDefault(_typeof2);

var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Util = {
    getSearch: function getSearch(key) {
        return new RegExp('[&?]' + key + '=([^&]*)', 'i').test(location.search) ? decodeURIComponent(RegExp.$1) : '';
    },
    isNull: function isNull(a) {
        return (typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a)) == "object" && !a;
    },
    getUrlParam: function getUrlParam(url, parameter) {
        url = url || location.href;
        var result = url.match(new RegExp("[\#|\?]([^#]*)[\#|\?]?"));
        url = "&" + (this.isNull(result) ? "" : result[1]);
        result = url.match(new RegExp("&" + parameter + "=", "i"));
        return this.isNull(result) ? undefined : url.substr(result.index + 1).split("&")[0].split("=")[1];
    },
    isWeixin: function isWeixin() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    },
    isIpad: function isIpad() {
        var getUA = navigator.userAgent.toLowerCase();
        return (/ipad/i.test(getUA)
        );
    },
    isIOS: function isIOS() {
        var i = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/;
        return i.test(navigator.userAgent);
    },
    isAndroid: function isAndroid() {
        var i = /\bAndroid([^;]+)/;
        return i.test(navigator.userAgent);
    },
    isShouLei: function isShouLei() {
        var ua = navigator.userAgent.toLowerCase();
        if (window.XLJSWebViewBridge || ua.match(/Thunder/i) == "thunder") {
            return true;
        } else {
            return false;
        }
    },
    ajax: function ajax(url, _success, _error) {
        _zepto2.default.ajax({
            url: url,
            dataType: 'jsonp',
            type: 'GET',
            timeout: 10 * 1000,
            success: function success(data) {
                _success && _success(data);
            },
            error: function error() {
                _error && _error();
            }
        });
    },
    initEvents: function initEvents(Events) {
        var key, keyArr, delElems, elems, events;
        var spiltElems = function spiltElems(elems) {
            return elems.split('&').join(',');
        };
        for (key in Events) {
            keyArr = key.split('|');
            switch (keyArr.length) {
                case 3:
                    delElems = spiltElems(keyArr[0]);
                    elems = spiltElems(keyArr[1]);
                    events = spiltElems(keyArr[2]);
                    delElems = document;
                    (0, _zepto2.default)(delElems).on(events, elems, Events[key]);
                    break;
                case 2:
                    elems = spiltElems(keyArr[0]);
                    events = spiltElems(keyArr[1]);
                    (0, _zepto2.default)(elems).on(events, Events[key]);
                    break;
                default:
                    break;
            }
        }
    },
    initUserInfo: function initUserInfo(callback) {
        client.data.getUserInfo({
            "forceLogin": 0
        }, function (rs) {
            Util.clearShouLeiCookie();
            window.SLUserInfo = null;
            if (rs.userInfo && rs.userInfo.userID) {
                window.SLUserInfo = rs;
                Util.setShouLeiCookie(rs.userInfo);
                if (typeof callback == 'function') {
                    callback();
                }
            }
        });
    },
    setShouLeiCookie: function setShouLeiCookie(data) {
        var config = {
            userID: "userid",
            sessionID: "sessionid",
            nickName: "usernick"
        };
        for (var i in data) {
            if (config[i]) {
                setCookie(config[i], encodeURIComponent(data[i]), 24, 1);
            }
        }
    },
    clearShouLeiCookie: function clearShouLeiCookie() {
        clearCookie();
    },
    download: function download(url, name, ref) {
        try {
            var data = {
                'max': 1,
                "type": 1,
                "list": [{
                    'name': name || '',
                    'url': url,
                    'ref_url': ref || location.href
                }]
            };
            window.share.addTasks((0, _stringify2.default)(data));
        } catch (e) {
            if (Util.isShouLei()) {
                client.data.addDownloadTask({
                    'name': name || '',
                    'url': url,
                    'refurl': ref || location.href
                });
            } else {
                location.href = "http://act.vip.xunlei.com/vip/download/?downloadUrl=" + url;
            }
        }
    },
    ipadSLhack: function ipadSLhack() {
        //iapd手雷input输入出现问题hack,如果发现ipad手雷input出现黑框，可以通过这个解决
        if (this.isIpad()) {
            var top = parseInt((0, _zepto2.default)(window).scrollTop()) - 3;
            (0, _zepto2.default)(window).scrollTop(top);
        }
    }
};

exports.default = Util;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var backDiv = null,
    popDiv = null;

var msgbox_tpl = __webpack_require__(75);
var active_cfg = window.active_cfg;

function msgbox(msg, opts) {
    msgbox.exit();
    opts = opts || {};
    var popDiv = createpopDiv();
    var btn_title = opts.btn_title || '确定';
    var btn_class = opts.btn_class || '';
    var btn_payid = opts.btn_payid || '';
    var btn_fn = opts.btn_fn || '';

    if (btn_payid) {
        btn_payid = 'payid="' + btn_payid + '"';
    }
    if (btn_fn) {
        opts.btn_href = opts.btn_href || 'javascript:;';
    }
    var btn_href = opts.btn_href || 'javascript:msgExit()';
    var btn_target = opts.btn_target == 1 ? '_blank' : '';
    var clickid = opts.clickid || "";
    popDiv.find("[name=msgbox_info]").html(msg);
    var btn = popDiv.find('[name=box_btn]');
    btn.replaceWith('<a class="btn_pop btn_ok ' + btn_class + '" ' + clickid + ' ' + btn_payid + ' href="' + btn_href + '" name="box_btn" title="' + btn_title + '" target="' + btn_target + '">' + btn_title + '</a>');;
    btn_fn && popDiv.find('[name=box_btn]').on('click', btn_fn);
    if (opts['close_href']) {
        var btn = popDiv.find('a.act_close_box');
        btn.replaceWith('<a href="' + opts['close_href'] + '" title="关闭" class="act-pop-close act_close_box">关闭</a>');
    }
    msgbox.id = 'act_msgbox_common';
    popDiv.show();
};

msgbox.show = function (id, opts) {
    msgbox.exit();
    opts = opts || {};
    if (opts.only) {
        backDiv = (0, _zepto2.default)('<div style="position:fixed;z-index:998;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.4);"></div>').appendTo('body');
        popDiv = (0, _zepto2.default)('#' + id).show();
        msgbox.id = id;
        return;
    }
    if ((0, _zepto2.default)('#' + id).hasClass('cover')) {
        (0, _zepto2.default)('#' + id).show();
    } else {
        var _id = id + '_cover';
        if ((0, _zepto2.default)('#' + _id).size()) {
            (0, _zepto2.default)('#' + _id).show();
        } else {
            if ((0, _zepto2.default)('#' + id).size() <= 0) {
                return;
            }
            var $popDiv = (0, _zepto2.default)('<div class="cover" id="' + _id + '"></div>');
            $popDiv.append((0, _zepto2.default)('#' + id).show()).appendTo('body');
            $popDiv.show();
        }

        id = _id;
    }
    msgbox.id = id;
};

msgbox.exit = function (id, opts) {
    (0, _zepto2.default)('#' + msgbox.id).hide();
    if (backDiv) {
        backDiv.remove();
        backDiv = null;
    }
};

function createpopDiv() {
    var popDiv = null;
    (0, _zepto2.default)('#act_msgbox_common').length ? popDiv = (0, _zepto2.default)('#act_msgbox_common') : popDiv = (0, _zepto2.default)(msgbox_tpl).appendTo('body');
    return popDiv;
}

msgbox.showErrorMsg = function (MSGID, opts) {
    if (active_cfg && active_cfg['msg']) {
        var MSG = active_cfg['msg'][MSGID];
    }
    var opts = opts;
    if (MSG) {
        opts = {
            btn_title: MSG['btn_text'],
            btn_href: MSG['btn_link'],
            btn_target: MSG['btn_action'],
            boxTitle: MSG['title'],
            btn_class: MSG['btn_class'],
            btn_payid: MSG['btn_payid']
        };
        msgbox(MSG['content'], opts);
    } else {
        msgbox(MSGID, opts);
    }
};

window.msgExit = msgbox.exit;

exports.default = msgbox;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(11);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(37);
var enumBugKeys = __webpack_require__(25);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(24)('keys');
var uid = __webpack_require__(14);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(4).f;
var has = __webpack_require__(2);
var TAG = __webpack_require__(7)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(7);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var core = __webpack_require__(9);
var LIBRARY = __webpack_require__(19);
var wksExt = __webpack_require__(27);
var defineProperty = __webpack_require__(4).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(44);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(63);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(19);
var $export = __webpack_require__(32);
var redefine = __webpack_require__(35);
var hide = __webpack_require__(3);
var has = __webpack_require__(2);
var Iterators = __webpack_require__(21);
var $iterCreate = __webpack_require__(50);
var setToStringTag = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(57);
var ITERATOR = __webpack_require__(7)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var core = __webpack_require__(9);
var ctx = __webpack_require__(48);
var hide = __webpack_require__(3);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(5) && !__webpack_require__(12)(function () {
  return Object.defineProperty(__webpack_require__(34)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var document = __webpack_require__(1).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(10);
var dPs = __webpack_require__(51);
var enumBugKeys = __webpack_require__(25);
var IE_PROTO = __webpack_require__(23)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(34)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(56).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(2);
var toIObject = __webpack_require__(6);
var arrayIndexOf = __webpack_require__(53)(false);
var IE_PROTO = __webpack_require__(23)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(37);
var hiddenKeys = __webpack_require__(25).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

exports.login = login;
exports.shouleiLogin = shouleiLogin;
exports.logout = logout;
exports.haslogin = haslogin;

var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

__webpack_require__(74);

var _util = __webpack_require__(8);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var times = 0;

function login(url) {
	shouleiLogin('', function () {
		loginInit();
	}, true);
};

function shouleiLogin(url, loginedFun, noreLoad) {
	try {
		var callback = (0, _stringify2.default)({
			"callback": "refreshAct"
		});
		window.share.goToLoginPageAndCallback(callback);
	} catch (e) {
		if (_util2.default.isShouLei()) {
			client.data.getUserInfo({
				"source": '',
				"forceLogin": 1
			}, function (rs) {
				if (rs.userInfo.userID) {
					window.SLUserInfo = rs;
					_util2.default.setShouLeiCookie(rs.userInfo);
				} else {
					window.SLUserInfo = null;
					_util2.default.clearShouLeiCookie();
				}
				if (typeof loginedFun == 'function') {
					loginedFun();
				}
				if (!noreLoad) {
					//异步的时候不要relaod,如果要reload写在function
					window.location.reload();
				}
			});
		} else {
			window.location.href = url || "http://act.vip.xunlei.com/waplogin/login.html?url=" + encodeURIComponent(location.href);
		}
	}
}
//调用退出
function logout() {
	try {
		var callback = (0, _stringify2.default)({
			"callback": "xlQuickLogin.logout"
		});
		window.share.goToLogoutPageAndCallback(callback);
	} catch (e) {}
}
//判读是否登录
function haslogin() {
	try {
		var userid = window.share.getUserId();
		if (userid <= 0) {
			return false;
		} else {
			return true;
		}
	} catch (e) {
		var sessionid = getCookie("sessionid");
		if (!sessionid || sessionid == '-1') {
			return false;
		}
		return true;
	}
}

window.haslogin = haslogin;
window.login = login;
window.logout = logout;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof2 = __webpack_require__(30);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = function template(id) {
	return cache[id] || (cache[id] = build(getTpl(id)));
};

var cache = {};

var build = function build(tpl) {
	return function (data) {
		var compiler = compile(tpl);
		return new compiler(data).toString();
	};
};

template.build = build;

var getTpl = function getTpl(id) {
	var el = document.getElementById(id);
	return el ? el.innerHTML : '';
};

var toString = function toString(value) {
	var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
	if (type !== 'string') {
		if (type === 'number') {
			value += '';
		} else if (type === 'function') {
			value = toString(value.call(value));
		} else {
			value = '';
		}
	}
	return value;
};

var escapeMap = {
	"<": "&#60;",
	">": "&#62;",
	'"': "&#34;",
	"'": "&#39;",
	"&": "&#38;"
};

var escapeFn = function escapeFn(s) {
	return escapeMap[s];
};

var escape = function escape(content) {
	return toString(content).replace(/&(?![\w#]+;)|[<>"']/g, escapeFn);
};

var isArray = Array.isArray || function (obj) {
	return Object.prototype.toString.call(obj) === '[object Array]';
};

var each = function each(data, callback) {
	var i,
	    len,
	    count = 0;
	if (isArray(data)) {
		for (i = 0, len = data.length; i < len; i++) {
			callback.call(data, data[i], i, data, i);
		}
	} else {
		for (i in data) {
			callback.call(data, data[i], i, data, count);
			count++;
		}
	}
};

var compile = template.compile = function (source, data) {

	var isNewEngine = ''.trim;
	var replaces = isNewEngine ? ["$o='';", "$o+=", ";", "$o"] : ["$o=[];", "$o.push(", ");", "$o.join('')"];
	var headerCode = "'use strict';var $e=this.$e,$f=this.$f,";
	var mainCode = replaces[0];
	var footerCode = "return new String(" + replaces[3] + ");";

	each(source.split("{{"), function (code, index) {
		code = code.split("}}");
		var $0 = code[0];
		var $1 = code[1];
		var len = code.length;
		if (code.length === 1) {
			mainCode += html($0);
		} else if (len === 2) {
			mainCode += logic($0);
			if ($1) {
				mainCode += html($1);
			}
		}
	});

	function stringify(code) {
		return "'" + code.replace(/('|\\)/g, '\\$1').replace(/\r/g, '\\r').replace(/\n/g, '\\n') + "'";
	}

	function html(code) {
		if (code) {
			code = replaces[1] + stringify(code) + replaces[2];
		}
		return code;
	}

	function logic(code) {
		code = code.replace(/^\s+|\s+$/, '');
		var split = code.split(/\s+/);
		var key = split.shift();
		var args = split.join(' ');
		switch (key) {
			case 'if':
				code = 'if(' + args + '){';
				break;

			case 'else':
				code = '}else{';
				break;

			case 'elseif':
				code = '}else if(' + args + '){';
				break;

			case '/if':
				code = '};';
				break;

			case 'for':
				split[0] = split[0] || '$d';
				split[1] = split[1] || '$v';
				split[2] = split[2] || '$k';
				code = '$f(' + split.shift() + ',function(' + split.join() + '){';
				break;

			case '/for':
				code = '});';
				break;

			case 'eval':
				code = args + ';';
				break;

			case '#':
				code = replaces[1] + "$e(" + code + ")" + replaces[2];
				break;

			default:
				code = replaces[1] + code + replaces[2];
				break;
		}
		return code;
	}
	var compiler = new Function("$d", headerCode + mainCode + footerCode);
	compiler.prototype.$e = escape;
	compiler.prototype.$f = each;
	return compiler;
};

exports.default = template;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(9);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(45), __esModule: true };

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(59);
module.exports = __webpack_require__(27).f('iterator');


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(47)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(31)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(17);
var defined = __webpack_require__(18);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(49);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(36);
var descriptor = __webpack_require__(13);
var setToStringTag = __webpack_require__(26);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(3)(IteratorPrototype, __webpack_require__(7)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(4);
var anObject = __webpack_require__(10);
var getKeys = __webpack_require__(22);

module.exports = __webpack_require__(5) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(38);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(6);
var toLength = __webpack_require__(54);
var toAbsoluteIndex = __webpack_require__(55);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(17);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(17);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(1).document;
module.exports = document && document.documentElement;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(2);
var toObject = __webpack_require__(58);
var IE_PROTO = __webpack_require__(23)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(18);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60);
var global = __webpack_require__(1);
var hide = __webpack_require__(3);
var Iterators = __webpack_require__(21);
var TO_STRING_TAG = __webpack_require__(7)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(61);
var step = __webpack_require__(62);
var Iterators = __webpack_require__(21);
var toIObject = __webpack_require__(6);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(31)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(64), __esModule: true };

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(65);
__webpack_require__(71);
__webpack_require__(72);
__webpack_require__(73);
module.exports = __webpack_require__(9).Symbol;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(1);
var has = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(5);
var $export = __webpack_require__(32);
var redefine = __webpack_require__(35);
var META = __webpack_require__(66).KEY;
var $fails = __webpack_require__(12);
var shared = __webpack_require__(24);
var setToStringTag = __webpack_require__(26);
var uid = __webpack_require__(14);
var wks = __webpack_require__(7);
var wksExt = __webpack_require__(27);
var wksDefine = __webpack_require__(28);
var enumKeys = __webpack_require__(67);
var isArray = __webpack_require__(68);
var anObject = __webpack_require__(10);
var toIObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(20);
var createDesc = __webpack_require__(13);
var _create = __webpack_require__(36);
var gOPNExt = __webpack_require__(69);
var $GOPD = __webpack_require__(70);
var $DP = __webpack_require__(4);
var $keys = __webpack_require__(22);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(40).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(29).f = $propertyIsEnumerable;
  __webpack_require__(39).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(19)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(3)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(14)('meta');
var isObject = __webpack_require__(11);
var has = __webpack_require__(2);
var setDesc = __webpack_require__(4).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(12)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(22);
var gOPS = __webpack_require__(39);
var pIE = __webpack_require__(29);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(38);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(6);
var gOPN = __webpack_require__(40).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(29);
var createDesc = __webpack_require__(13);
var toIObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(20);
var has = __webpack_require__(2);
var IE8_DOM_DEFINE = __webpack_require__(33);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(5) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {



/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28)('asyncIterator');


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28)('observable');


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setCookie(name, value, hours, isBaseDomain) {
    value = value + '';
    if (isBaseDomain != undefined && isBaseDomain == 1) {
        setRealCookie(name, value, hours, 1);
    } else {
        var vipcookie = getRealCookie('vipcookie');
        if (_zepto2.default.trim(value) == '') {
            //删除cookie
            if (vipcookie != '') {
                var check = getCookie(name);
                if (check != '') {
                    var cookies = vipcookie.split('&');
                    var newcookie = new Array();
                    for (var i = 0; i < cookies.length; i++) {
                        ary = cookies[i].split('=');
                        if (ary.length > 1 && ary[0] != name) {
                            newcookie.push(cookies[i]);
                        }
                    }
                    vipcookie = newcookie.join('&');
                }
            }
        } else {
            //添加cookie
            //删除原生cookie中的此值
            setRealCookie(name, '', 0);
            if (vipcookie == '') {
                vipcookie = _zepto2.default.trim(name) + '=' + encodeURIComponent(value);
            } else {
                //check if has the same item , if so , replace it , otherwise add it.
                var check = getCookie(name);
                if (check != '') {
                    var cookies = vipcookie.split('&');
                    for (var i = 0; i < cookies.length; i++) {
                        var _ary = cookies[i].split('=');
                        if (_ary.length > 1 && _ary[0] == name) {
                            cookies[i] = name + '=' + encodeURIComponent(value);
                            break;
                        }
                    }
                    vipcookie = cookies.join('&');
                } else {
                    vipcookie = vipcookie + '&' + _zepto2.default.trim(name) + '=' + encodeURIComponent(value);
                }
            }
        }
        if (hours != undefined) {
            setRealCookie('vipcookie', vipcookie, hours);
        } else {
            setRealCookie('vipcookie', vipcookie);
        }
    }
}

function setRealCookie(name, value, hours, isBaseDomain) {
    var domain = '';
    if (window.location.href.indexOf('jsq.xunlei.com') != -1) {
        domain = "jsq.xunlei.com";
    } else if (window.location.href.indexOf('act-vip-ssl.xunlei.com') != -1) {
        domain = "act-vip-ssl.xunlei.com";
    } else {
        domain = window.location.host;
    }
    if (arguments.length > 2) {
        var expireDate = new Date(new Date().getTime() + hours * 3600000);
        if (isBaseDomain != undefined && isBaseDomain == 1) {
            document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=xunlei.com; expires=" + expireDate.toGMTString();
        } else {
            document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=" + domain + "; expires=" + expireDate.toGMTString();
        }
    } else {
        document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=" + domain;
    }
}

function getCookie(name) {
    var val = getRealCookie(name);
    if (_zepto2.default.trim(val) == '') {
        var vipcookie = getRealCookie('vipcookie');
        if (_zepto2.default.trim(vipcookie) == '') {
            return '';
        }
        var cookies = vipcookie.split('&');
        for (var i = 0; i < cookies.length; i++) {
            var _ary2 = cookies[i].split('=');
            if (_ary2.length > 1 && _ary2[0] == name) {
                return decodeURIComponent(_ary2[1]);
            }
        }
        return '';
    } else {
        return _zepto2.default.trim(val); //如果cookie中有该值，优先使用该值
    }
}

function getRealCookie(name) {
    return document.cookie.match(new RegExp("(^" + name + "| " + name + ")=([^;]*)")) == null ? "" : decodeURIComponent(RegExp.$2);
}

function clearCookie() {
    //清除子域名
    var ckeys = ["vipcookie", "vip_nickname", "ci_session", "vip_ci_session", "_x_a_"];
    for (var i = 0, len = ckeys.length; i < len; i++) {
        setRealCookie(ckeys[i], "", 0);
    }
    //主域名
    var ckeys1 = ["sessionid", "usrname", "nickname", "usernick", "userid", "usertype", "usernewno", "blogresult", "score", "order", "isvip", "sex", "upgrade", "logintype", "checkans", "checkpwd", "jumpkey"];
    for (var i = 0, len = ckeys1.length; i < len; i++) {
        setRealCookie(ckeys1[i], "", 0, 1);
    }
}

window.setCookie = setCookie;
window.setRealCookie = setRealCookie;
window.getCookie = getCookie;
window.getRealCookie = getRealCookie;
window.clearCookie = clearCookie;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cover xl_wrap\" id=\"act_msgbox_common\" style=\"display:none;\"> <div class=\"xl_pop pop_type_1\" style=\"display:block\"> <div class=\"xl_pop_m\"> <p class=\"text_nor\" name=\"msgbox_info\"></p> </div> <div class=\"xl_pop_b\"> <a href=\"javascript:msgExit()\" class=\"btn_pop act_close_box\">取消</a> <a href=\"javascript:;\" class=\"btn_pop btn_ok act_close_box\" name=\"box_btn\">确定</a> </div> </div></div>"

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @封装用户会员各种信息文件
 * 需要在用户登录后才能调用这个文件，在访问接口asynProxy后调用有效
 * @author caizhenbo
 * create at 2015/4/11
 */

var User = {};

/**
 * 迅雷会员
 */
User.isVip = function () {
    var paytype = parseInt(getCookie("vip_paytype"));
    var isvip = parseInt(getCookie("vip_isvip"));
    if ((isvip == 1 || isvip == 2) && paytype < 1000) {
        return 1;
    } else {
        return 0;
    }
};
/**
 * 迅雷会员
 */
User.isStopVip = function () {
    //return true;
    var isvip = parseInt(getCookie("vip_isvip"));
    if (isvip == 2) {
        return true;
    } else {
        return false;
    }
};

/***
 * 迅雷迷你会员
 */
User.isMiniVip = function () {
    var paytype = parseInt(getCookie("vip_paytype"));
    var isvip = parseInt(getCookie("vip_isvip"));
    var vas_type = parseInt(getCookie("vas_type"));
    if (this.isVip() && paytype < 1000 && vas_type == 1) {
        return 1;
    } else {
        return 0;
    }
};

/**
 * 普通会员非白金
 */
User.isNormalVip = function () {
    var isvip = parseInt(getCookie("vip_isvip"));
    var vas_type = parseInt(getCookie("vas_type"));
    if (this.isVip() && vas_type == 2) {
        return 1;
    } else {
        return 0;
    }
};
/**
 * 白金会员
 */
User.isPlatinumVip = function () {
    var paytype = parseInt(getCookie("vip_paytype"));
    var isvip = parseInt(getCookie("vip_isvip"));
    var vas_type = parseInt(getCookie("vas_type"));
    var level = parseInt(getCookie("vip_level"));
    if (this.isVip() && vas_type == 3 || this.isVip() && vas_type == 4 && level > 5) {
        return 1;
    } else {
        return 0;
    }
};
/**
 * 手机用户
 */
User.isMobileVip = function () {
    var mobilevip = [3, 8, 9, 15, 103];
    var paytype = parseInt(getCookie("vip_paytype"));
    var isvip = parseInt(getCookie("vip_isvip"));
    var vas_type = parseInt(getCookie("vas_type"));
    if (this.isVip() && vas_type <= 3 && _in_array(paytype, mobilevip)) {
        return 1;
    } else {
        return 0;
    }
};

/**
 * 判断是否体验会员
 */
User.isTiyan = function () {
    var isvip = getCookie('vip_isvip');
    var vip_paytype = getCookie('vip_paytype');
    if (this.isVip() == 1 && vip_paytype > 1000) {
        return true;
    } else {
        return false;
    }
};

/**
 * 判断是否钻石会员，先改为超级
 */
User.isDiamondVip = function () {
    var isvip = getCookie('vip_isvip');
    var vas_type = getCookie('vas_type');
    if (this.isVip() == 1 && vas_type == 5) {
        return true;
    } else {
        return false;
    }
};

/**
 * 判断是否钻石会员
 */
User.isSuperVip = function () {
    var isvip = getCookie('vip_isvip');
    var vas_type = getCookie('vas_type');
    if (this.isVip() == 1 && (vas_type == 5 || vas_type == 4)) {
        return true;
    } else {
        return false;
    }
};

/**
 * 判断是否快鸟会员
 */
User.isKuainiaoVip = function () {
    var isvip = getCookie('vip_kn_isvip');
    return isvip == 1 ? true : false;
};

/**
 * 判断是否为过期会员
 */
User.isOldvip = function () {
    var vip_level = getCookie("vip_level"); //会员级别;已登陆的非会员默认为0;
    var vip_isvip = getCookie("vip_isvip"); // 是否是 vip
    var vip_expiredate = getCookie("vip_expiredate");
    if (vip_level != null && vip_level != "" && vip_level != "0" && vip_isvip == 0) {
        return true;
    } else {
        return false;
    }
};

/**
 * *
 * 判断是否是新用户
 */
User.isNewUser = function () {
    var isVip = getCookie('vip_isvip'),
        level = getCookie('vip_level');
    if (isVip == 0 && level == '' || level == 0) {
        return 1;
    }
    return 0;
};

/**
 * 判断是否为靓号
 */
User.isGoodnum = function () {
    var vip_isgoodnum = getCookie("vip_is_good_number");
    if (vip_isgoodnum != null && vip_isgoodnum != "" && vip_isgoodnum == "1") {
        return true;
    } else {
        return false;
    }
};

/**
 * 是否会员子帐号
 */
User.isChild = function () {
    var ischild = parseInt(getCookie("ischild"));
    if (ischild == "1" || getCookie("vip_ischild") == 1) {
        return 1;
    } else {
        return 0;
    }
};
/**
 * 是否为年费会员
 */
User.isYearVip = function () {
    var isyear = parseInt(getCookie("vip_isyear"));
    if (isyear == "1") {
        return 1;
    } else {
        return 0;
    }
};

/**
 * 是否为2009年10月前购买白金会员的历史用户
 */
User.isHistoryVip = function () {
    var ishistory = parseInt(getCookie("history"));
    if (ishistory == "1") {
        return 1;
    } else {
        return 0;
    }
};

/**
 * 获取用户的昵称
 */
User.nickname = function () {
    var nickname = getCookie("vip_nickname") ? getCookie("vip_nickname") : getCookie("usernick");
    return nickname;
};

/*
 *迅雷用户名
 */
User.xlUsername = function () {
    var usrname = getCookie("usrname");
    var Usernewno = getCookie("Usernewno");
    if (usrname != '' && usrname != '0') {
        return usrname;
    }
    return Usernewno;
};
/**
 * 获取用户的头像
 */
User.avatar = function () {

    return 'http://img.user.kanimg.com/usrimg/' + getCookie('userid') + '/100x100';
};

/**
 *用户的成长值
 */
User.daily = function () {
    var daily = getCookie('vip_daily');
    return daily;
};

/**
 *用户等级
 *
 */
User.level = function () {
    var level = getCookie('vip_level');
    if (level == 'level' || level == '') {
        level = 0;
    }
    return level;
};

/**
 * 用户图标url
 */
User.iconUrl = function () {
    var iconUrl = '';
    if (User.isSuperVip()) {
        iconUrl = 'http://vip.xunlei.com/vip_service/supervip/';
    } else {
        iconUrl = 'http://vip.xunlei.com/vip_service/mycenter/myvip.html';
    }
    return iconUrl;
};

/*
 **返回会员身份判断
 * return 0:非会员:1：迷你会员；2:普通会员；3：白金会员；4:钻石会员；
 */
User.identity = function () {
    if (this.isMiniVip()) {
        return 1;
    }
    if (this.isNormalVip()) {
        return 2;
    }
    if (this.isPlatinumVip()) {
        return 3;
    }
    if (this.isDiamondVip()) {
        return 4;
    }
    if (this.isSuperVip()) {
        return 5;
    }
    return 0;
};

/*
 **会员有效期
 */
User.expiredate = function () {
    var expiredate = getCookie('vip_expiredate');
    if (expiredate) {
        return expiredate;
    } else {
        return '无';
    }
};

/*
 **用户会员图标
 **return 用户快鸟会员身份图标class
 */
User.knIcon = function () {
    var iconClass = '';
    if (getCookie('vip_kn_isvip') == 1) {
        iconClass = 'icvip ickn';
    } else {
        iconClass = 'icvip icknhui';
    }

    return iconClass;
};

/*
 *用户会员图标
 * return 用户会员身份图标class
 */
User.vipIcon = function () {
    var id = parseInt(getCookie('vas_type'));
    var level = this.level();
    var iconClass = '';
    switch (id) {
        case 1:
            iconClass = 'icvip icvip0' + level + 'hui';
            break;
        case 2:
            iconClass = 'icvip icvip0' + level;
            break;
        case 3:
            iconClass = 'icvip icgoldvip icgold0' + level;
            break;
        case 4:
            if (level >= 6) {
                iconClass = 'icvip icgoldvip icgold0' + level;
            } else {
                iconClass = 'icvip icsuper0' + level;
            }
            // iconClass ='icvip iczuan icz0'+ level;
            break;
        case 5:
            iconClass = 'icvip icsuper0' + level;
            break;
        default:
            iconClass = 'icvip icvip0' + level;
            break;
    }
    if (getCookie('vip_isvip') == 0) {
        //增加快鸟非会员显示快鸟图标
        iconClass = iconClass + 'hui';
    }
    return iconClass;
};

/*
 *用户会员身份
 * return 用户会员名称
 */
User.vipName = function () {
    var name = '非会员';
    var id = parseInt(getCookie('vas_type'));
    var level = this.level();
    if (!User.isVip() && !User.isOldvip()) {
        return name;
    }
    switch (id) {
        case 1:
        case 2:
            name = '迅雷普通会员';
            break;
        case 3:
            if (level >= 6) {
                name = '迅雷白金钻石会员';
            } else {
                name = '迅雷白金会员';
            }
            break;
        case 4:
            if (level >= 6) {
                name = '迅雷白金钻石会员';
            } else {
                name = '迅雷超级会员';
            }
            // iconClass ='icvip iczuan icz0'+ level;
            break;
        case 5:
            name = '迅雷超级会员';
            break;
        default:
            name = '迅雷会员';
            break;
    }
    name = name + 'VIP' + level;
    if (getCookie('vip_isvip') == 0) {

        name = '过期' + name;
    }
    return name;
};

/*
 *用户到期时长剩余多少个月，向下取整
 * return 剩余月份
 */
User.levelMonth = function () {
    var isVip = getCookie('vip_isvip'),
        expiredays = getCookie('vip_expiredays');
    if (isVip == 1) {
        return Math.floor(expiredays / 31);
    }
    return 0;
};

User.payText = function () {

    if (User.isStopVip()) {
        return '激活会员';
    }
    return getCookie('pay_tips') || '开通白金会员';
};

function _in_array(val, arr) {
    for (var i in arr) {
        if (arr[i] == val) {
            return true;
        }
    }
    return false;
}

//initUserInfo();
exports.default = User;

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

var _util = __webpack_require__(8);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(41);

var _main = __webpack_require__(80);

var _main2 = _interopRequireDefault(_main);

var _msgbox = __webpack_require__(15);

var _msgbox2 = _interopRequireDefault(_msgbox);

var _user = __webpack_require__(76);

var _user2 = _interopRequireDefault(_user);

var _template = __webpack_require__(42);

var _template2 = _interopRequireDefault(_template);

var _tj = __webpack_require__(81);

var _tj2 = _interopRequireDefault(_tj);

var _share = __webpack_require__(82);

var _share2 = _interopRequireDefault(_share);

var _package = __webpack_require__(84);

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var thunderjsversion = _package2.default.m;
setCookie('thunderjsversion', thunderjsversion, 24, 1);

(0, _zepto2.default)(document).on('click', '.act_prize_list, .act_prize', function () {
    if (!haslogin()) {
        login();
    } else {
        prizelist();
    }
    return false;
}).on('click', '.act_address', function () {
    if (!haslogin()) {
        login();
        return false;
    }
    if (!/ipad/i.test(navigator.userAgent.toLowerCase())) {
        window.open(domainList.act + '/wap/addr.html');
    } else {
        location.href = domainList.act + '/wap/addr.html';
    }
    return false;
});

__webpack_require__(85);
var textSlider = __webpack_require__(86);
__webpack_require__(87);

var prizelist = function prizelist() {
    __webpack_require__.e/* require.ensure */(0).then((function (require) {
        var prizelist = __webpack_require__(77);

        prizelist();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var pay = __webpack_require__(89);
window.thunder = function (fn) {
    (0, _zepto2.default)(function () {
        fn.call({
            util: _util2.default,
            main: _main2.default,
            ajax: _util2.default.ajax,
            msgbox: _msgbox2.default,
            user: _user2.default,
            template: _template2.default,
            pay: pay,
            share: _share2.default,
            textSlider: textSlider,
            tj: _tj2.default
        });
        _main2.default.start();
        delete window.thunder;
    });
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

var _msgbox = __webpack_require__(15);

var _msgbox2 = _interopRequireDefault(_msgbox);

var _util = __webpack_require__(8);

var _util2 = _interopRequireDefault(_util);

var _login = __webpack_require__(41);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!window.active_cfg) {
    throw '配置文件不存在';
}

window.domainList = {
    dyactive2: 'http://dyactive2.vip.xunlei.com',
    dyactive: 'http://dyactive.vip.xunlei.com',
    dyact: 'http://dyact.vip.xunlei.com',
    dynamic: 'http://dynamic.vip.xunlei.com',
    dypay: 'http://dypay.vip.xunlei.com',
    act: 'http://act.vip.xunlei.com',
    vip: 'http://vip.xunlei.com'
};

window.actid = active_cfg.base.actid;
document.title = active_cfg.base.actname;
document.domain = 'xunlei.com';
document.addEventListener('touchstart', function () {});

// var msgbox = require('./msgbox.js');
// var util = require('./util.js');

var ajax = _util2.default.ajax;


(function ($) {
    //修改zepto的方法，增加innerWidth、innerHeight和outerWidth、outerHeight
    var ioDim = function ioDim(dimension, includeBorder) {
        return function (includeMargin) {
            var sides, size, elem, oldStyle;
            if (this) {
                elem = this;
                size = elem[dimension]();
                sides = {
                    width: ["left", "right"],
                    height: ["top", "bottom"]
                };
                sides[dimension].forEach(function (side) {
                    size += parseInt(elem.css("padding-" + side), 10);
                    if (includeBorder) {
                        size += parseInt(elem.css("border-" + side + "-width"), 10);
                    }
                    if (includeMargin) {
                        size += parseInt(elem.css("margin-" + side), 10);
                    }
                });
                return size;
            } else {
                return null;
            }
        };
    };
    ["width", "height"].forEach(function (dimension) {
        var Dimension = dimension.substr(0, 1).toUpperCase() + dimension.substr(1);
        $.fn["inner" + Dimension] = ioDim(dimension, false);
        $.fn["outer" + Dimension] = ioDim(dimension, true);
    });

    //由于引用了fx_methods.js，导致show方法会修改元素的样式，现在重写为原来的show方法
    $.fn.show = function () {
        return this.each(function () {
            this.style.display == "none" && (this.style.display = '');
            if (getComputedStyle(this, '').getPropertyValue("display") == "none") {
                this.style.display = defaultDisplay(this.nodeName);
            }
        });
    };

    function defaultDisplay(nodeName) {
        var element = void 0,
            display = void 0,
            elementDisplay = {};
        if (!elementDisplay[nodeName]) {
            element = document.createElement(nodeName);
            document.body.appendChild(element);
            display = getComputedStyle(element, '').getPropertyValue("display");
            element.parentNode.removeChild(element);
            display == "none" && (display = "block");
            elementDisplay[nodeName] = display;
        }
        return elementDisplay[nodeName];
    }
})(_zepto2.default);

_zepto2.default.jsonp = function (url, data, callback) {
    if (typeof data === 'function') {
        callback = data;
        data = '';
    }

    var _callback = function _callback(rs) {
        if (rs.result === -100) {
            setCookie('sessionid', '', 0, 1);
            setCookie('userid', '', 0, 1);
            logout();
            login();
        } else {
            callback(rs);
        }
    };

    return _zepto2.default.ajax({
        url: url,
        data: data,
        dataType: 'jsonp',
        success: _callback
    });
};

var times = 0;

function start() {
    init();

    if (_util2.default.isShouLei()) {
        try {
            //在手雷里面全部在当前页面跳转
            window.open = function (url) {
                window.top.location.href = url;
                return false;
            };

            var sessionid = window.share.getSessionId();
            var userid = window.share.getUserId();
            if (sessionid && userid) {
                setCookie('sessionid', sessionid, 24, 1);
                setCookie('userid', userid, 24, 1);
                times++;
                loginInit();
            } else {
                loginInit.fail && loginInit.fail();
            }
        } catch (e) {
            _util2.default.initUserInfo(function () {
                times++;
                loginInit();
            });
        }
        //手雷监听事件
        document.addEventListener('XLJSWebViewBridgejsReady', function () {
            if (times >= 1) {
                return false;
            }
            _util2.default.initUserInfo(function () {
                loginInit();
            });
        }, false);
    }
    //非手雷
    if (haslogin() && !_util2.default.isShouLei()) {
        loginInit();
    } else {
        loginInit.fail && loginInit.fail();
    }
}

function init() {
    ajax('http://dyactive2.vip.xunlei.com/iface/?action=init&keyurl=wap&actid=' + actid, function (rs) {
        if (rs.result == 0) {
            var data = rs.data;
            data.message && _msgbox2.default.showErrorMsg(data.message);
            init.cb && init.cb(data);
        }
    });
}

function onInit(cb) {
    init.cb = cb;
}

function loginInit() {
    _zepto2.default.jsonp(domainList.dyactive2 + '/iface/?action=logininit&keyurl=wap&actid=' + actid, {
        userInfo: 1
    }, function (rs) {
        if (rs.result == 0) {
            var data = rs.data;
            rs.data.message && _msgbox2.default.showErrorMsg(rs.data.message);
            refreshVipUserInfo(data.userInfo);
            loginInit.suc && loginInit.suc(data);
        } else if (rs.result === -100) {
            setCookie('sessionid', '', 0, 1);
            setCookie('userid', '', 0, 1);
            loginInit.fail && loginInit.fail();
        }
    });
}

window.loginInit = loginInit;

function onLoginInit(suc, fail) {
    loginInit.suc = suc;
    loginInit.fail = fail;
}

function refreshVipUserInfo(data) {
    if (!data) {
        return;
    }
    setCookie('vip_sessionid', getCookie('sessionid'));
    var regcookie = function regcookie(cname, name) {
        if (data[name] != undefined) setCookie(cname, data[name]);
    };
    regcookie('vip_nickname', 'nickname');
    regcookie('vip_usrname', 'usrname');
    regcookie('vip_growvalue', 'growvalue');
    regcookie('vip_expiredate', 'expiredate');
    regcookie('vip_level', 'level');
    regcookie('vip_isyear', 'isyear');
    regcookie('vip_paytype', 'paytype');
    regcookie('vip_isvip', 'isvip');
    regcookie('vip_daily', 'daily');
    regcookie('vip_payname', 'payname');
    regcookie('vip_is_good_number', 'is_good_number');
    regcookie('vip_num_is_open_vip', 'num_is_open_vip');
    regcookie('vip_num_due_time', 'num_due_time');
    regcookie('vip_safebox', 'safebox');
    regcookie('vip_autopay', 'autopay');
    regcookie('act_cmb', 'act_cmb');
    regcookie('vas_type', 'vas_type');
    regcookie('vip_ischild', 'ischild');
    regcookie('vip_kn_isvip', 'kn_isvip');
    regcookie('vip_kn_level', 'kn_level');
    regcookie('vip_kn_expiredate', 'kn_expiredate');
    regcookie('kn_isvip', 'kn_isvip');
    regcookie('kn_level', 'kn_level');
    regcookie('kn_expiredate', 'kn_expiredate');
}

exports.default = {
    start: start,
    onInit: onInit,
    onLoginInit: onLoginInit,
    init: init,
    loginInit: loginInit
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _zepto2.default)(function () {
	(function () {
		var xla = window.xla || (window.xla = []);
		xla.push({
			type: 'config',
			appid: 20009,
			secret: 'a8d1fc968b2fe1fe21bfe8f2abc4ba3a'
		});
		var s = document.createElement('script');
		s.src = '//res-etl-ssl.xunlei.com/v1.0.0/xla.min.js';
		s.async = true;
		document.getElementsByTagName('head')[0].appendChild(s);
	})();

	(function () {
		var s = document.createElement("script");
		s.src = "//hm.baidu.com/hm.js?be94a17b28798d3dc61eb511641cdd9a";
		s.async = true;
		document.getElementsByTagName('head')[0].appendChild(s);
	})();
});

function tj(id) {
	if (!id) {
		return;
	}
	window.habo_aid = id;
	var s = document.createElement('script');
	s.src = '/static/com/pv_click_v2.js';
	s.async = true;
	document.getElementsByTagName('head')[0].appendChild(s);
}

exports.default = tj;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

var _util = __webpack_require__(8);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tpl = __webpack_require__(83);
// var util = require('../common/util.js');


var title,
    link,
    desc,
    imgUrl,
    ua = navigator.userAgent;

var UA_IOS_REG = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/;
var UA_ANDROID_REG = /\bAndroid([^;]+)/;

var isIOS = UA_IOS_REG.test(ua);

function append() {
	var shareText;
	shareText = '点击右上角<br>发送给朋友or分享朋友圈哟';
	if ((0, _zepto2.default)('#share_pop').length == 0) {
		(0, _zepto2.default)(tpl).appendTo('body');
	}
	(0, _zepto2.default)('#share_pop .text_share').html(shareText);
	(0, _zepto2.default)('#share_pop').show();
	(0, _zepto2.default)('#share_pop').unbind().click(function (event) {
		(0, _zepto2.default)('#share_pop').hide();
		return false;
	});
}

function initShareData(opt) {
	var opt = opt || {};
	var defaultSharePic = getUrl() + 'img/share.jpg';
	title = opt.title || document.title, link = opt.link || location.href, desc = opt.desc || '', imgUrl = opt.imgUrl || defaultSharePic;
}

var Share = initShareData;
//获取当前目录url
function getUrl() {
	var href = location.href,
	    index = href.indexOf('?'),
	    defaultSharePic;
	if (index != -1) {
		href = href.substring(0, index);
	}
	//剔除index.html
	index = href.indexOf('index.html');

	if (index != -1) {
		href = href.substring(0, index);
	}

	if (!/\/$/.test(location.href)) {
		href = href + '/';
	}
	return href;
}

//分享到微信
function shareToWX(opt) {
	var typeUrl, appId;

	if (!_util2.default.isWeixin()) {
		return false;
	}
	//區分网游和会员
	typeUrl = domainList.dyactive + '/weixin_huiyuan/server.php?type=jweixinSign';
	appId = 'wxffca8b088e4134ac';

	_zepto2.default.jsonp(typeUrl + '&url=' + encodeURIComponent(location.href.split('#')[0]) + '&time=' + new Date().getTime(), function (rs) {
		if (rs.result == 0) {
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: appId, // 必填，公众号的唯一标识
				timestamp: rs.data.timestamp, // 必填，生成签名的时间戳
				nonceStr: rs.data.nonceStr, // 必填，生成签名的随机串
				signature: rs.data.signature, // 必填，签名，见附录1
				jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			});
			wx.ready(function () {
				wx.onMenuShareTimeline({
					title: title, // 分享标题
					link: link, // 分享链接
					imgUrl: imgUrl, // 分享图标
					success: function success() {},
					cancel: function cancel() {}
				});

				wx.onMenuShareAppMessage({
					title: title, // 分享标题
					desc: desc, // 分享描述
					link: link, // 分享链接
					imgUrl: imgUrl, // 分享图标
					type: '', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function success() {},
					cancel: function cancel() {}
				});
			});
		} else {
			wx.error(function (res) {
				console.log(res);
			});
		}
	});
}

function shareToOldSL() {
	window.share.displayUmengShareBtn((0, _stringify2.default)({
		url: link,
		wxUrl: link,
		imgUrl: imgUrl,
		title: title,
		type: 'activity',
		content: desc
	}));
}

//分享到ios手雷
function shareToIOSSL() {
	//防止ios过长，微博不能分享
	var shareLink = link;
	var length = link.indexOf('?');

	if (length != -1 && link == location.href) {
		shareLink = shareLink.substring(0, length);
	}
	//防止#被转码，折中去掉
	length = link.indexOf('#');

	if (length != -1) {
		shareLink = shareLink.substring(0, length);
	}

	var shareClient = {};
	shareClient.url = shareLink;
	shareClient.imgUrl = imgUrl;
	shareClient.title = desc;
	shareClient.type = 'activity';
	shareClient.headline = title;
	var param = '{"jsondata":"' + encodeURIComponent((0, _stringify2.default)(shareClient)) + '"}';
	loadURL("xlscheme://clienthost/showUmengShareBtn?jsondata=" + encodeURIComponent(param));
}

//分享到新版手雷
function shareToNewSL(data) {
	client.data.shareTo({
		'sharePlatform': 1,
		'shareHeadline': title,
		'shareImageUrl': imgUrl,
		'shareUrl': link
	}, function (response) {
		var result = response.result;
		if (result == 0) {//分享成功
			/*if (typeof window.ACTCONFIG.successCallback == 'function') {
   	window.ACTCONFIG.successCallback();
   }*/
		} else if (result == 2) {//分享取消
			/*if (typeof window.ACTCONFIG.cancleCallback == 'function') {
   	window.ACTCONFIG.cancleCallback();
   }*/
		}
	});
}

//直接打开新浪微博分享
function shareSina(data) {
	var openUrl = 'http://service.weibo.com/share/share.php?url=' + encodeURIComponent(link) + '&title=' + encodeURIComponent(title) + '&pic=' + encodeURIComponent(imgUrl);
	window.open(openUrl);
}

//友盟分享
function loadURL(url) {
	var iFrame;
	iFrame = document.createElement("iframe");
	iFrame.setAttribute("src", url);
	iFrame.setAttribute("style", "display:none;");
	iFrame.setAttribute("height", "0px");
	iFrame.setAttribute("width", "0px");
	iFrame.setAttribute("frameborder", "0");
	document.body.appendChild(iFrame);
	// 发起请求后这个iFrame就没用了，所以把它从dom上移除掉
	iFrame.parentNode.removeChild(iFrame);
}

initShareData();
shareToWX();
var Events = {
	'document|#act_wx_share,.act_wx_share,.act_share|click': function documentAct_wx_shareAct_wx_shareAct_shareClick() {
		var needLogin = (0, _zepto2.default)(this).attr('needlogin');
		if (needLogin == 1 && !haslogin()) {
			login();
			return false;
		}
		var shareData = (0, _zepto2.default)(this).attr('data-shareinfo');
		if (shareData) {
			shareData = JSON.parse(shareData);
			initShareData(shareData);
		}

		if (_util2.default.isWeixin()) {
			append();
			shareToWX();
		} else if (_util2.default.isShouLei()) {
			//新版手雷
			shareToNewSL();
		} else if (window.share && window.share.displayUmengShareBtn) {
			//判断旧版手雷
			shareToOldSL();
		} else if (isIOS) {
			shareToIOSSL();
		} else {
			shareSina();
		}
	}
};
Share.shareToWX = shareToWX;
Share.initShareData = initShareData;
_util2.default.initEvents(Events);
module.exports = Share;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<div class=\"xl_wrap\" id=\"share_pop\" style=\"display:none;position:fixed;height: 100%;width: 100%;top: 0px;z-index: 99999;\"><div class=\"share\"><span class=\"share_arw\"></span><p class=\"text_share\">点击右上角<br>发送给朋友or分享朋友圈哟</p></div></div>"

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = {"name":"thunderjs","version":"1.0.0","private":true,"description":"打包移动端页面","m":"1.5.0m","main":"index.js","scripts":{"m":"node webpack.config.js"},"licence":"ISC","devDependencies":{"babel-core":"^6.26.0","babel-loader":"^7.1.2","babel-plugin-transform-runtime":"^6.23.0","babel-preset-env":"^1.6.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","compressed-string-loader":"^0.0.1","scp2":"git+https://github.com/jqroom/node-scp2.git","webpack":"^3.5.5"}}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

var _util = __webpack_require__(8);

var _util2 = _interopRequireDefault(_util);

var _msgbox = __webpack_require__(15);

var _msgbox2 = _interopRequireDefault(_msgbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// var util = require('../common/util.js');
var islottery = false;
// var msgbox = require('../common/msgbox.js');

var actid = active_cfg.base.actid;
var jinku = {};

if (_util2.default.isWeixin()) {
	jinku['urlname'] = '立即使用';
	jinku['url'] = 'http://act.vip.xunlei.com/weixin_huiyuan/weixin_pay/';
} else {
	jinku['urlname'] = '立即查看';
	jinku['url'] = 'http://vip.xunlei.com/vip_service/mycenter/vault.html';
}

var msg_cofig = {
	"address": {
		opts: {
			btn_title: "填写资料",
			btn_href: "javascript:void(0);",
			btn_target: "0",
			boxTitle: "恭喜亲中奖啦！",
			btn_class: "act_address"
		}
	},
	"info": {
		opts: {
			btn_title: "我的收货地址",
			btn_href: "javascript:void(0);",
			btn_target: "0",
			boxTitle: "恭喜亲中奖啦！",
			btn_class: "act_qq_sub"
		}
	}
};

_zepto2.default.fn.lottery = function (_config) {
	var config = {
		giftItem: 'li', //单个奖品选择器
		sort: [0, 1, 2, 7, 3, 6, 5, 4], //排序，默认为顺序
		targetClass: 'on', //选中时的class，默认on
		fastSpeed: 80, //快速阶段的速度(定时器时间间隔)，默认80
		slowSpeed: 444, //慢速阶段的速度(定时器时间间隔)，默认400
		startStep: 5, //开头的慢速阶段跑几步，默认4
		endStep: 6, //结束的慢速阶段跑几步，默认4
		startBtn: '.act_lottery_btn',
		lottery_url: location.protocol + '//dyactive2.vip.xunlei.com/iface/?action=getLottery&actid=', //获取抽奖结果的url
		ani: true,
		lotteryAfter: null,
		gid: ''
	};

	_zepto2.default.extend(config, _config);

	var islottery;
	var timeIntervalId; //定时器
	var curStatus; //0:停止  1:启动截断 2:中间快速阶段  3:中奖减速阶段
	var giftIndex; //抽中奖品的位置,-1表示还没获得
	var curIndex; //当前在哪个位置
	var runCount; //累计总共跑了几个位置
	var endCallback; //用来注册结束时回调的函数
	function reset() {
		curStatus = 0; //0:停止  1:启动截断 2:中间快速阶段  3:中奖减速阶段
		giftIndex = -1; //抽中奖品的位置,-1表示还没获得
		curIndex = 0; //当前在哪个位置
		runCount = 0; //累计总共跑了几个位置
	}
	reset();
	var $lotteryBox = this.eq(0);
	var giftCount = $lotteryBox.find(config.giftItem).length; //奖品总数
	var idx = 0;
	if (!config.sort || config.sort.length != giftCount) {
		$lotteryBox.find(config.giftItem).each(function () {
			(0, _zepto2.default)(this).attr('sort', idx);
			idx++;
		});
	} else {
		$lotteryBox.find(config.giftItem).each(function () {
			(0, _zepto2.default)(this).attr('sort', config.sort[idx]);
			idx++;
		});
	}

	function run() {
		reset();
		focusToNext();
		curStatus = 1; //开始
		myInterval(config.slowSpeed);
	}

	//设置定时器，私有函数
	function myInterval(speed) {
		clearInterval(timeIntervalId);
		timeIntervalId = setInterval(function () {
			runCount++;
			curIndex = runCount % giftCount;
			focusToNext();
			stepFunction();
		}, speed);
	}

	//设置当前dom状态，私有函数
	function focusToNext() {
		$lotteryBox.find(config.giftItem).removeClass(config.targetClass);
		$lotteryBox.find(config.giftItem + '[sort="' + curIndex + '"]').eq(0).addClass(config.targetClass);
	}

	//每跑一步检测当前状态，私有函数
	function stepFunction() {
		if (curStatus == 1 && runCount == config.startStep) {
			curStatus = 2; //加速
			myInterval(config.fastSpeed);
		}
		if (curStatus == 2 && runCount >= config.startStep + giftCount * 2) {
			//至少要快速跑一圈
			if (giftIndex != -1) {
				var needNum = giftCount - config.endStep - (curIndex - giftIndex);
				if (needNum == 0 || needNum == giftCount) {
					curStatus = 3; //中奖减速阶段
					myInterval(config.slowSpeed);
				}
			}
		}
		if (curStatus == 3 && curIndex == giftIndex) {
			end();
		}
	}

	function end() {
		clearInterval(timeIntervalId);
		setTimeout(function () {
			endCallback && endCallback();
		}, 200);
	}

	function setGift(_giftIndex, _endCallback) {
		run();
		giftIndex = parseInt(_giftIndex);
		endCallback = _endCallback;
	}

	function afterLottery(rs) {
		if (config.after && config.after(rs) === false) {
			return;
		}
		if (msg_cofig[rs.data.fafang]) {
			_msgbox2.default.showErrorMsg(rs.msg, msg_cofig[rs.data.fafang]['opts']);
		} else {
			_msgbox2.default.showErrorMsg(rs.msg);
		}
	}

	function start() {
		if (islottery) return;
		islottery = true;
		_zepto2.default.ajax({
			url: config.lottery_url,
			dataType: 'jsonp',
			data: {
				actid: actid,
				gid: config.gid
			},
			success: function success(rs) {
				if (config.before && config.before(rs) === false) {
					islottery = false;
					return;
				}
				if (rs.result == 0) {
					if (config.ani) {
						setGift(rs.data.frontid, function () {
							afterLottery(rs);
							islottery = false;
						});
					} else {
						afterLottery(rs);
						islottery = false;
					}
				} else {
					_msgbox2.default.showErrorMsg(rs.msg);
					islottery = false;
				}
			}
		});
	}
	(0, _zepto2.default)(config.startBtn).on('click', function () {
		if (!haslogin()) {
			login();
			return false;
		}

		start();
	});
	return {
		start: start
	};
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

var _template = __webpack_require__(42);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_zepto2.default.fn.textSlider = function (set) {
    var config = _zepto2.default.extend({
        direction: 'top',
        speed: 2000,
        wait: 1000,
        child: 'ul',
        line: 1,
        per: 1,
        html: ''
    }, set);
    return this.each(function () {
        _zepto2.default.fn.textSlider.scllor((0, _zepto2.default)(this), config);
    });
};
// var template = require('../common/template.js');


_zepto2.default.fn.textSlider.scllor = function ($this, config) {
    var wrap = $this.find(config.child).eq(0);
    if (config.html) {
        wrap.html(config.html);
    } else {
        if (config.data && wrap.html()) {
            var _html = _template2.default.build(wrap.html())(config.data);
            wrap.html(_html);
        }
    }

    var timer;
    var sub = wrap.children();
    if (sub.length === 0) {
        return;
    }
    var auto = true;
    config.sub = sub.get(0).tagName.toLocaleString();
    var liHight, upHeight, liWigth, leftWidth;
    var ing = false;
    var scrollUp = function scrollUp() {
        liHight = 0;
        upHeight = 0;
        for (var i = 0; i < config.line; i++) {
            liHight = wrap.children().eq(i * config.per).outerHeight(true);
            upHeight = upHeight - liHight;
        }
        ing = true;
        wrap.animate({
            marginTop: upHeight
        }, config.speed, function () {
            wrap.find(config.sub).slice(0, config.per * config.line).appendTo(wrap);
            wrap.css({
                marginTop: 0
            });
            ing = false;
            auto && (timer = setTimeout(scrollUp, config.wait));
        });
    };

    var scrollLeft = function scrollLeft() {
        liWigth = 0;
        leftWidth = 0;
        for (var i = 0; i < config.line; i++) {
            liWigth = wrap.children().eq(i * config.per).outerWidth(true);
            leftWidth = leftWidth - liWigth;
        }
        ing = true;
        wrap.animate({
            marginLeft: leftWidth
        }, config.speed, function () {
            wrap.find(config.sub).slice(0, config.per * config.line).appendTo(wrap);
            wrap.css({
                marginLeft: 0
            });
            ing = false;
            auto && (timer = setTimeout(scrollLeft, config.wait));
        });
    };

    var fn;
    switch (config.direction) {
        case 'left':
            fn = scrollLeft;
            break;
        default:
            fn = scrollUp;
    }
    var autoPlay = function autoPlay() {
        auto = true;
        if (!ing) {
            timer = setTimeout(fn, config.wait);
        }
    };
    var autoStop = function autoStop() {
        auto = false;
        clearTimeout(timer);
    };
    if (!('ontouchstart' in window)) {
        // $this.hover(autoStop, autoPlay);
        $this.on('mouseenter', autoStop).on('mouseleave', autoPlay);
    }
    fn();
};

module.exports = function (opt, data, direction) {
    if (typeof opt === 'string') {
        opt = { wrap: opt, data: data, direction: direction };
    }
    (0, _zepto2.default)(opt.wrap).eq(0).textSlider(opt);
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

var _template = __webpack_require__(42);

var _template2 = _interopRequireDefault(_template);

var _util = __webpack_require__(8);

var _util2 = _interopRequireDefault(_util);

var _msgbox = __webpack_require__(15);

var _msgbox2 = _interopRequireDefault(_msgbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// var template = require('../common/template.js');
var ajax = _util2.default.ajax;

var logisticsId = 'act_logistics_popbox';
var totalLogisticsLength = 0;
var ajaxFlag = false;
var actid = active_cfg.base.actid;
var tpl = __webpack_require__(88);

function logistics(url) {
    if (ajaxFlag) {
        return;
    }
    url = domainList.dyactive2 + '/iface/?action=logininit&keyurl=wap&actid=' + actid;
    ajaxFlag = true;
    ajax(url, function (rs) {
        ajaxFlag = false;
        var result = parseInt(rs.result);
        if (result == 0) {
            var list = rs.data.prizelist || {};
            var listData = [];
            _zepto2.default.each(list, function (i, v) {
                if (v.fafang === 'address') {
                    listData.push(v);
                }
            });
            totalLogisticsLength = listData.length;
            if (listData.length >= 0) {
                var html = _template2.default.build(tpl)(listData);
                if (!(0, _zepto2.default)('#' + logisticsId).length) {
                    (0, _zepto2.default)('body').append(html);
                } else {
                    (0, _zepto2.default)('#' + logisticsId).replaceWith(html).show();
                }
                _msgbox2.default.show(logisticsId);
            }
        } else if (result == -100) {
            logout();
            login();
        } else {
            (0, _msgbox2.default)(rs.msg);
        }
    }, function () {
        ajaxFlag = false;
    });
}

(0, _zepto2.default)(document).on("click", "#act_logistics_popbox .turn_nav a", function () {
    var $this = (0, _zepto2.default)(this);
    if ($this.hasClass('disable')) {
        return;
    }

    var $curGoods = (0, _zepto2.default)("#act_logistics_popbox").find("div.cur_logistics");
    var idx = $curGoods.attr('index');
    idx = idx && Number(idx) || 0;

    if ($this.hasClass('prev')) {
        idx--;
        $curGoods.removeClass('cur_logistics').hide();
        $curGoods.prev().addClass('cur_logistics').show();
    } else if ($this.hasClass('next')) {
        idx++;
        $curGoods.removeClass('cur_logistics').hide();
        $curGoods.next().addClass('cur_logistics').show();
    }

    if (idx <= 0) {
        $this.parent().find("a.prev").addClass('disable');
    } else {
        $this.parent().find("a.prev").removeClass('disable');
    }

    if (idx >= totalLogisticsLength - 1) {
        $this.parent().find("a.next").addClass('disable');
    } else {
        $this.parent().find("a.next").removeClass('disable');
    }
}).on('click', '.act_logistics', function () {
    if (!haslogin()) {
        login();
    } else {
        logistics();
    }
});
module.exports = logistics;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cover xl_wrap\" id=\"act_logistics_popbox\"> <div class=\"pop_logistics\"> <div class=\"pop_hd\"> <p class=\"pop_tit\">我的物流</p> <a href=\"javascript:msgExit();\" class=\"pop_close\" title=\"关闭\">X</a> </div> <div class=\"pop_cont\"> {{if $d.length}} {{for $d}} <div class=\"{{$k < 1 ? \'cur_logistics\' : \'\'}}\" index=\"{{$k}}\" style=\"display: {{($k < 1 ? \'\' : \'none\') }};\"> <dl> <dt>奖品名称：</dt> <dd class=\"tc_red\"> {{for $v.tname.split(\"+\")}}<span class=\"award_name\">{{$v}}</span>{{/for}} </dd> </dl> <dl> <dt>物流状态：</dt> {{if $v.keycode}} <dd class=\"tc_red\">已发货</dd> {{else}} <dd class=\"tc_red\">待发货</dd> {{/if}} </dl> <dl> <dt>承运来源：</dt> {{if $v.keycode }} <dd>{{$v.keycode.split(\',\')[0] }}</dd> {{else}} <dd>暂无</dd> {{/if}} </dl> <dl> <dt>运单编号：</dt> {{if $v.keypwd }} <dd>{{$v.keypwd }}</dd> {{else}} <dd>暂无</dd> {{/if}} </dl> <dl> <dt>官方电话：</dt> {{if $v.keycode && $v.keycode.split(\',\')[1]}} <dd>{{$v.keycode.split(\',\')[1]}}</dd> {{else}} <dd>暂无</dd> {{/if}} </dl> </div> {{/for}} {{else}} <div> <dl> <dt>奖品名称：</dt> <dd class=\"tc_red\"> <span class=\"award_name\">暂无</span> </dd> </dl> <dl> <dt>物流状态：</dt> <dd class=\"tc_red\">暂无</dd> </dl> <dl> <dt>承运来源：</dt> <dd>暂无</dd> </dl> <dl> <dt>运单编号：</dt> <dd>暂无</dd> </dl> <dl> <dt>官方电话：</dt> <dd>暂无</dd> </dl> </div> {{/if}} <a href=\"http://www.kuaidi100.com/?from=openv\" class=\"link_query\">查看物流进展 &gt;&gt;</a> <div class=\"turn_nav\" style=\"display: {{$d.length > 1 ? \'\' : \'none\'}};\"> <a href=\"javascript:;\" class=\"prev disable\" title=\"上一页\">上一页</a> <a href=\"javascript:;\" class=\"next\" title=\"下一页\">下一页</a> </div> </div> </div></div>"

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _zepto = __webpack_require__(0);

var _zepto2 = _interopRequireDefault(_zepto);

var _util = __webpack_require__(8);

var _util2 = _interopRequireDefault(_util);

var _user = __webpack_require__(76);

var _user2 = _interopRequireDefault(_user);

var _msgbox = __webpack_require__(15);

var _msgbox2 = _interopRequireDefault(_msgbox);

var _template = __webpack_require__(42);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tpl = __webpack_require__(90);
// var template = require('../common/template.js');

var actid = window.active_cfg.base.actid;
var cfg = '';
var payway = '';
var ajax = _util2.default.ajax;
var version = 0;
var weixinInstall = false;
var alipayInstall = false;

var payid;
var shouleiPayType = 1; //手雷支付类型 1代表微信，2代表支付宝

if (_util2.default.isShouLei() && _util2.default.isAndroid()) {
    clientInterface.device.getAppMetaData(function (data) {
        version = data['versionCode'];
    });
    client.app.checkAppInstalled({
        appSchemes: ['com.tencent.mm', 'com.eg.android.AlipayGphone'] // ['mqq', 'weixin'] appSchemes参数必须数组
    }, function (data) {
        if (version >= 10907 && version < 10915) {
            weixinInstall = false;
            alipayInstall = false;
        } else {
            weixinInstall = data['com.tencent.mm'];
            alipayInstall = data['com.eg.android.AlipayGphone'];
        }
    });
}
/**
 * 初始化页面支付浮层
 * @param  string subpayid 支付浮层aid
 * @return null
 */
function initPage(subpayid) {

    if (!subpayid) {
        for (var x in active_cfg.pay) {
            subpayid = x;
            break;
        }
    }
    payid = subpayid;
    var month = [];
    cfg = active_cfg['pay'][subpayid];
    payway = cfg['payway'] || '';

    for (var i in cfg['price']) {
        cfg['price'][i]['month'] = i;
        cfg['price'][i]['monthunit'] = '个月';
        if (payway == 'auto_bj') {
            cfg['price'][i]['tips'] = '连续包月';
        }

        if (cfg['price'][i]['tips'] != '' && cfg['price'][i]['tips'].indexOf('(') == -1) {
            cfg['price'][i]['tips'] = ' ( ' + cfg['price'][i]['tips'] + ' )';
        }
        month.push(cfg['price'][i]);
    }

    window.aidfrom = cfg['aidfrom'] || '';

    (0, _zepto2.default)('#pay-pop').remove();
    shouleiPayType = weixinInstall ? '1' : '2';
    var html = _template2.default.build(tpl)({
        listData: cfg['pricedesc'] == 1 ? month.reverse() : month,
        monthinfo: cfg['monthinfo'] || 0,
        weixinInstall: weixinInstall,
        alipayInstall: alipayInstall,
        payway: payway
    });

    (0, _zepto2.default)('body').append(html);

    if (cfg['biztype'] == 'upgradevip' || cfg['biztype'] == 'upgradesuper' || cfg['biztype'] == 'knupsuperv1') {
        var userid = getCookie('userid');
        var vastype = getCookie('vip_vastype');
        var biztype_config = {
            upgradevip: 3,
            upgradesuper: 5,
            knupsuperv1: 14
        };
        (0, _zepto2.default)('#month_list').hide();
        (0, _zepto2.default)('#upgrade_list').show();
        var requestUrl = 'http://dypay.vip.xunlei.com/phonepay/getprice/?source=vipcenter&type=1&userid=' + userid + '&vastype=' + biztype_config[cfg['biztype']];
        ajax(requestUrl, function (rs) {
            //  返回说明：
            // ret      0 成功；1 无可升级订单;
            // prize    总价格
            // uprate   升级折扣
            // tdays    升级总天数
            // ndays    普通订单总天数
            // mtdays   迷你订单总天数
            // nprize   普通订单价格
            // mprize   迷你订单价格
            // discount 优惠折扣 （原价 = prize / discount）
            // autopayprice 自动续费价格 （仅支付宝/微信白金包月返回）
            if (rs.ret == 0) {
                // $('#div_month_update').html('<span class="selpad02"></span>');
                if (rs.uprate == 1) {
                    (0, _zepto2.default)('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间' + rs.tdays + ' 天，需 ' + rs.price + ' 元</li>');
                    (0, _zepto2.default)('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间' + rs.tdays + ' 天，仅不到12元/月升级超级会员，再送1次翻牌赢2年会员的机会&gt;</li>');
                } else {
                    (0, _zepto2.default)('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间' + rs.tdays + ' 天，需 ' + rs.price + ' 元，已打 ' + rs.uprate * 10 + ' 折</li>');
                    (0, _zepto2.default)('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间' + rs.tdays + ' 天，仅不到12元/月升级超级会员，再送1次翻牌赢2年会员的机会&gt;</li>');
                }
            } else {
                (0, _zepto2.default)('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间 无升级时长</li>');
            }
            showmoney();
            (0, _zepto2.default)('#oPrize').hide();
        });
    } else {
        (0, _zepto2.default)('#upgrade_list').hide();
        (0, _zepto2.default)('#month_list').show();
        // $('#oPrize').show();
    }

    if (cfg['usecash'] == 1) {
        //优惠券
        initCash();
    } else {
        (0, _zepto2.default)('#cash_zone').hide();
    }
    if (window.aidfrom != '' && typeof window.aidfrom != 'undefined') {
        (0, _zepto2.default)('#pay_btn').attr({
            'clickid': window.aidfrom
        });
    }
    // $('')
    (0, _zepto2.default)('#pay-pop h3').text(cfg['title']);
    initPayEvent();
}

/**
 * 绑定页面的支付事件
 * @return null
 */
function initPayEvent() {
    //事件綁定
    (0, _zepto2.default)(document).on('click', '#month_list li', function (event) {
        (0, _zepto2.default)('#month_list li').removeClass('cho');
        (0, _zepto2.default)(this).addClass('cho');
        var p = (0, _zepto2.default)(this).data('prize');
        var o = (0, _zepto2.default)(this).data('oprize');
        if (o == undefined || o == '') {
            (0, _zepto2.default)('#oPrize').hide();
        } else {
            (0, _zepto2.default)('#oPrize').show();
            (0, _zepto2.default)('#oPrize_num').text(o);
        }
        showmoney(p);
        return false;
    });

    //代金券列表
    (0, _zepto2.default)('#cash_list').on('click', 'li', function (event) {
        (0, _zepto2.default)('#cash_list li').removeClass('cur');
        (0, _zepto2.default)(this).addClass('cur');
        var item = (0, _zepto2.default)(this).data('item');
        (0, _zepto2.default)('#cash_input').val(item);
    });

    //支付
    (0, _zepto2.default)(document).off('click.pay').on('click.pay', '#pay_btn', function (event) {
        if (!haslogin()) {
            login();
            return false;
        }
        var month = (0, _zepto2.default)('.pay_form ul li.cho').attr('month');
        goPay(month, payid, actid);

        var paytype_shangbao = '';
        if (_util2.default.isWeixin()) {
            paytype_shangbao = 'wx';
        } else if (_util2.default.isShouLei() && _util2.default.isAndroid() && version >= 10710) {
            paytype_shangbao = 'shoulei';
        }

        if (xla && xla.push) {
            xla.push({
                type: 'event',
                category: 'pay_commit',
                action: 'pay_commit_qrzf',
                extdata: {
                    pageid: 'pay_hdzf_page',
                    referfrom: _util2.default.getUrlParam(location.href, 'referfrom'),
                    aidfrom: _util2.default.getUrlParam(location.href, 'aidfrom'),
                    userid: getCookie('userid'),
                    usertype: getCookie('vas_type'),
                    default_producttype: cfg.biztype,
                    default_monthtype: (0, _zepto2.default)("#month_list li:eq(0)").attr("month") + "m",
                    default_paytype: payway || 'zfb',
                    producttype: cfg.biztype,
                    monthtype: month + "m",
                    paytype: payway || paytype_shangbao || 'zfb'
                }
            });
        }

        return false;
    });

    (0, _zepto2.default)(document).on('click', '#pay-pop .xl_pop_close', function (event) {
        if (xla && xla.push) {
            xla.push({
                type: 'event',
                category: 'page_close',
                action: 'page_close_x',
                extdata: {
                    pageid: 'pay_hdzf_page',
                    referfrom: _util2.default.getUrlParam(location.href, 'referfrom'),
                    aidfrom: _util2.default.getUrlParam(location.href, 'aidfrom'),
                    userid: getCookie('userid'),
                    usertype: getCookie('vas_type')
                }
            });
        }
    });
}

/**
 * 验证展示购买价格处理
 * @param  string money
 * @return null
 */
function showmoney(money) {
    var month = (0, _zepto2.default)('li.cho').attr('month');
    var money = +(0, _zepto2.default)('li.cho').attr('data-prize');
    if (money <= 0 || global_paycenter['cash'] == 10 && month < 3 && global_paycenter['cash_unlimit'] != 1) {
        // 无效，3个月及以上
        money = money;
        (0, _zepto2.default)('#po_cash').val('');
    } else {
        money = money - global_paycenter['cash'];
        (0, _zepto2.default)('#po_cash').val(money);
    }
    (0, _zepto2.default)('#prize').text(money);
}

/**
 * 购买下单处理
 * @param  string month 购买的月份
 * @param  string payid 购买的浮层id
 * @param  string actid 活动id
 * @return undefined
 */
function goPay(month, payid, actid) {
    var month = month || 1,
        defaultReferfrom = active_cfg['pay'][payid]['referfrom_wap'],
        referfrom = _util2.default.getUrlParam(location.href, 'referfrom') || defaultReferfrom,
        callbackUrl,
        po_cash = (0, _zepto2.default)('#cash_input').val(),
        urlIndex = location.href.indexOf('?'),

    // 活动邀请
    inviteid = _util2.default.getUrlParam(location.href, 'uid') || '',
        payUrl;

    //支付完成后设置回退函数
    if (urlIndex != -1) {
        callbackUrl = location.href.substr(0, urlIndex) + '?po_pid=' + payid + '&month=' + month + '&paysucess=1';
    } else {
        callbackUrl = location.href + '?po_pid=' + payid + '&po_cash=' + po_cash + '&month=' + month + '&paysucess=1';
    }

    //增加京东支付，只要配置京东支付都直接购买，不执行后面逻辑
    if (payway == 'jd') {
        payUrl = formUrl(domainList.dypay + '/actpay/activepay/', {
            'po_way': 'jd_5',
            'po_platform': 'wap',
            'po_active': 'activeadmin',
            'po_cash': po_cash,
            'po_actid': actid,
            'po_pid': payid,
            'po_month': month,
            'po_inviteid': inviteid,
            'referfrom': referfrom,
            'aidfrom': window.aidfrom,
            'callback': +new Date().getTime(),
            'bgurl': encodeURIComponent(callbackUrl),
            'fgurl': encodeURIComponent(callbackUrl)

        });
        setCookie('submitOrder', 1);
        // window.open(payUrl);
        window.location.href = payUrl;
        return false;
    }

    //连续包月
    if (payway == 'auto_bj') {
        monthlyPay();
        return false;
    }

    //微信支付
    if (_util2.default.isWeixin()) {
        var typeUrl;
        if (location.host == 'act.vip.xunlei.com' || location.host == 'vip.xunlei.com') {
            typeUrl = 'http://act.vip.xunlei.com/weixin_huiyuan/weixin_pay/platform.html';
        } else {
            typeUrl = 'http://act.vip.xunlei.com/weixin_jsq/weixin_pay/platform.html';
        }

        payUrl = formUrl(typeUrl, {
            'userid': getCookie('userid'),
            'po_way': 'wap',
            'po_platform': 'wap',
            'po_active': 'activeadmin',
            'po_cash': po_cash,
            'po_actid': actid,
            'po_pid': payid,
            'month': month,
            'po_inviteid': inviteid,
            'referfrom': referfrom,
            'aidfrom': window.aidfrom,
            'callback': +new Date().getTime(),
            'bgurl': encodeURIComponent(callbackUrl),
            'fgurl': encodeURIComponent(callbackUrl)

        });
        setCookie('submitOrder', 1);
        window.open(payUrl);
        return false;
    }

    //如何是手雷
    if (_util2.default.isShouLei() && _util2.default.isAndroid() && version >= 10710 && version < 10907) {
        var payObj = {
            payType: shouleiPayType,
            vasType: 999,
            orderType: 0,
            userid: getCookie('userid'),
            //userid: 501,
            reportRefer: referfrom,
            monthOrTDays: month,
            orderVoucher: po_cash,
            paramExt1: encodeURIComponent((0, _stringify2.default)({
                po_actid: actid,
                po_pid: payid,
                po_inviteid: inviteid,
                po_cash: po_cash,
                po_data: ''
            }))
        };
        clientInterface.ui.pay(payObj, function (data) {
            setCookie('submitOrder', 1);
            if (data.errorCode == 0) {
                msgExit();
                (0, _msgbox2.default)('支付成功？', {
                    'btn_title': '成功',
                    'btn_class': 'refreshInfo',
                    'btn_notitle': '未支付',
                    'btn_noclass': 'refreshInfo'
                });
            } else {}
        });
        return false;
    } else if (_util2.default.isShouLei() && _util2.default.isAndroid() && version >= 10915) {
        // 新版的手雷支付
        var payObj = {
            payType: shouleiPayType,
            activeId: 2003001, //这里传入每个支付类型的activeId
            userid: getCookie('userid'),
            reportRefer: referfrom,
            monthOrTDays: month,
            orderVoucher: '',
            paramExt1: (0, _stringify2.default)({ //新的sdk不需要再urlencode
                actid: actid,
                pid: payid,
                po_inviteid: inviteid,
                po_cash: po_cash
            })
        };

        clientInterface.ui.pay(payObj, function (data) {
            setCookie('submitOrder', 1);
            if (data.errorCode == 0) {
                msgExit();
                (0, _msgbox2.default)('支付成功？', {
                    'btn_title': '成功',
                    'btn_class': 'refreshInfo',
                    'btn_notitle': '未支付',
                    'btn_noclass': 'refreshInfo'
                });
            } else {}
        });
        return false;
    }

    payUrl = formUrl(domainList.dypay + '/actpay/activepay/', {
        'po_way': 'wap',
        'po_platform': 'wap',
        'po_active': 'activeadmin',
        'po_cash': po_cash,
        'po_actid': actid,
        'po_pid': payid,
        'po_month': month,
        'po_inviteid': inviteid,
        'referfrom': referfrom,
        'aidfrom': window.aidfrom,
        'callback': +new Date().getTime(),
        'bgurl': encodeURIComponent(callbackUrl),
        'fgurl': encodeURIComponent(callbackUrl)

    });

    setCookie('submitOrder', 1);
    window.open(payUrl);
}

/**
 * 白金手机包月购买
 * @return {[type]} [description]
 */
function monthlyPay() {
    _util2.default.ajax(payUrl, function (data) {
        if (_util2.default.isWeixin()) {

            location.href = data.ext;
        } else {

            var gatewayUrl = encodeURIComponent(data.ext);
            var startUrl = 'alipays://platformapi/startapp?appId=20000067&url=' + gatewayUrl;
            var signUrl = "http://d.alipay.com/i/index.htm?iframeSrc=" + encodeURIComponent(startUrl);
            location.href = signUrl;
        }
    });
    setCookie('submitOrder', 1);
}

/**
 * 生成链接的url
 * @param  string url  提单地址
 * @param  {object} data 参数
 * @return
 */
function formUrl(url, data) {
    var requestData = data || {},
        requestArry = [];
    for (var name in data) {
        requestArry.push(name + '=' + data[name]);
    }
    return url + (url.indexOf('?') > -1 ? '&' : '?') + requestArry.join('&');
}

//代金券有关逻辑的函数;
var global_paycenter = {
    'cash_state': -1,
    cash: 0
    //检测代金券
};var cash_check = function cash_check() {
    // $('#cash_list').hide();
    if (_zepto2.default.trim((0, _zepto2.default)('#cash_input').val()).length == 16) {
        var html = '正在检测代金券...';
        (0, _zepto2.default)('#cash_status').html(html).show();
        var checkurl = domainList.dyact + '/cash/check_json/0/' + _zepto2.default.trim((0, _zepto2.default)('#cash_input').val()) + '?cachetime=' + new Date().getTime();
        _util2.default.ajax(checkurl, function (data) {
            global_paycenter['cash_state'] = data.state;
            check_rule(data);
        });
    } else {
        global_paycenter['cash'] = 0;
        showmoney();
        global_paycenter['cash_state'] = -1;
        (0, _zepto2.default)('#cash_status').html('');
    }
    try {
        if ((0, _zepto2.default)('#cash_input').val().indexOf('代金券') === -1) {
            (0, _zepto2.default)('#po_cash').val(_zepto2.default.trim((0, _zepto2.default)('#cash_input').val()));
        }
        cash_tips();
    } catch (e) {}
},
    cash_check2 = function cash_check2() {
    var cash_input = (0, _zepto2.default)('#cash_input').val();
    var length = _zepto2.default.trim((0, _zepto2.default)('#cash_input').val()).length;
    var imgbase = 'http://img.vip.xunlei.com/img/base/';
    var imgwow = '<img src="' + imgbase + 'wow16x16.png" align="absmiddle" />';
    //检测代金券长度
    if (length && length < 16 && cash_input.indexOf('代金券') === -1 || length > 16) {
        (0, _zepto2.default)('#cash_status').html('您输入的代金券位数不符').show();
    } else if (length == 0) {
        global_paycenter['cash'] = 0;
        global_paycenter['cash_state'] = -1;
        showmoney();
        (0, _zepto2.default)('#cash_status').html('');
        cash_tips();
    } else {
        cash_check();
    }
},
    check_rule = function check_rule(data) {
    switch (data.state) {
        case 0:
            /*if (data.cash_minus == 10 && data.unlimit != 1) {
                $('#cash_status').show().html('该代金券仅支付3个月会员及以上可用！再省' + data.cash_minus + '元</font>！');
            } else {
                 if (getMoney() < 0) {
                    $('#cash_status').show().html('该代金券仅下单金额大于' + data.cash_minus + '元可用！再省' + data.cash_minus + '元</font>！');
                } else {
                    $('#cash_status').show().html('该代金券可用！再省' + data.cash_minus + '元</font>！');
                }
            }*/
            if (getMoney() < 0 || getMoney() - data.limit_money < 0) {
                (0, _zepto2.default)('#cash_status').show().html('该代金券仅下单金额大于' + data.limit_money + '元可用！');
                data.cash_minus = 0;
            } else {
                (0, _zepto2.default)('#cash_status').show().html('该代金券可用！再省' + data.cash_minus + '元</font>！');
                global_paycenter['can_use_cash'] = true;
            }
            global_paycenter['cash'] = data.cash_minus;
            global_paycenter['cash_unlimit'] = data.unlimit;
            showmoney();
            break;
        case 1:
            (0, _zepto2.default)('#cash_status').show().html('参数错误');
            global_paycenter['cash'] = 0;
            showmoney();
            break;
        case 2:
            (0, _zepto2.default)('#cash_status').show().html('代金券已过期');
            global_paycenter['cash'] = 0;
            showmoney();
            break;
        case 3:
            var min = parseInt(data.min) % 60;
            var hour = parseInt(parseInt(data.min) / 60);
            (0, _zepto2.default)('#cash_status').show().html('该代金券已被锁定，离解锁时间还剩' + hour + '小时' + min + '分钟');
            global_paycenter['cash'] = 0;
            showmoney();
            break;
        case 4:
            (0, _zepto2.default)('#cash_status').show().html('该代金券已经被使用');
            global_paycenter['cash'] = 0;
            showmoney();
            break;
        case 5:
            (0, _zepto2.default)('#cash_status').show().html('不存在该代金券');
            global_paycenter['cash'] = 0;
            showmoney();
            break;
        case 6:
            (0, _zepto2.default)('#cash_status').show().html('该代金券为其他用户的,您使用无效');
            global_paycenter['cash'] = 0;
            showmoney();
            break;
    }
},
    cash_tips = function cash_tips() {
    var cash_val = (0, _zepto2.default)('#cash_input').val();
    if (cash_val == '' || cash_val.indexOf('代金券') !== -1) {
        var cash_tips = '';
        if ((0, _zepto2.default)('li.cho').attr('month') >= 3) {
            cash_tips = '可用10元以下代金券';
        } else {
            cash_tips = '';
        }
        (0, _zepto2.default)('#cash_input').attr('placeholder', cash_tips);
        (0, _zepto2.default)('#cash_input').css({
            'font-size': '12px',
            'color': '#888888'
        });
    } else {
        (0, _zepto2.default)('#cash_input').css({
            'font-size': '14px',
            'color': '#000000'
        });
    }
},
    getMoney = function getMoney() {
    var month = (0, _zepto2.default)('li.cho').attr('month');
    var money = '0.0';
    if (cfg['biztype'] == 'upgradevip' || cfg['biztype'] == 'upgradesuper' || cfg['biztype'] == 'knupsuper') {
        money = (0, _zepto2.default)('#nmUpdate').data('price');
    } else {
        money = cfg['price'][month]['price'];
    }
    return parseInt(money);
};

/**
 * 代金券初始化
 * @return {[type]} [description]
 */
function initCash() {
    getCashList();
    cash_check();

    (0, _zepto2.default)('i.ico_down').click(function () {
        (0, _zepto2.default)('#cash_list').toggle();
        return false;
    });
    (0, _zepto2.default)('#cash_list').on('click', 'li', function () {
        var item = (0, _zepto2.default)(this).data('item');
        (0, _zepto2.default)('#cash_input').val(item);
        cash_check();
    });
    (0, _zepto2.default)('#cash_input').on('keyup', function () {

        cash_check2();
    }).on('blur', function () {

        cash_check2();
    });
}

/**
 * 获取用户的代金券列表
 * @return null
 */
function getCashList() {
    var url = domainList.dyact + '/cash/cash_list' + "?_ts=" + new Date().getTime();
    _util2.default.ajax(url, function (rs) {
        (0, _zepto2.default)('#cash_list').html('');
        var ret = rs.ret;
        var cash_data = rs.data;
        var html = [];
        if (ret == 0 && cash_data) {
            for (var i in cash_data) {
                var prize = i / 100;
                if (cfg.cashlist && cfg.cashlist.length > 0 && cfg.cashlist.indexOf(String(prize)) == -1) {
                    continue;
                }
                var cash = cash_data[i]['fcard'];
                html.push('<li class="" data-item="' + cash + '"><i class="ico_p_radio"></i> ' + prize + '元</li>');
            }

            if (html.length > 0) {
                (0, _zepto2.default)('#cash_zone').show();
            } else {
                (0, _zepto2.default)('#cash_zone').hide();
                return;
            }

            (0, _zepto2.default)('#cash_list').html(html.join('')).show();
            (0, _zepto2.default)('#cash_list li').eq(0).click().click();
        } else {
            (0, _zepto2.default)('i.ico_down').hide();
        }
    });
}

function pay(payid) {
    if (!haslogin()) {
        login();
        return false;
    }

    if (_user2.default.isChild()) {
        (0, _msgbox2.default)('抱歉，您使用的是迅雷子帐号，请使用主帐号来参加活动！');
        return false;
    }

    if (_user2.default.isMobileVip()) {
        (0, _msgbox2.default)('抱歉，手机用户不能参与此活动！');
        return false;
    }

    if (_user2.default.isStopVip()) {
        (0, _msgbox2.default)('抱歉的通知您：您是暂停用户无法参加本次活动！');
        return false;
    }

    msgExit();
    initPage(payid);
    _msgbox2.default.show('pay-pop');
    typeof send_web_pv != 'undefined' && send_web_pv('pay_pop_success');

    if (xla && xla.push) {
        xla.push({
            type: 'event',
            category: 'page_load',
            action: 'page_load_succ',
            extdata: {
                pageid: 'pay_hdzf_page',
                referfrom: _util2.default.getUrlParam(location.href, 'referfrom'),
                aidfrom: _util2.default.getUrlParam(location.href, 'aidfrom'),
                userid: getCookie('userid'),
                usertype: getCookie('vas_type')
            }
        });
    }

    return false;
}
//页面支付事件绑定
var Events = {
    'document|.act_vip|click': function documentAct_vipClick() {
        payid = (0, _zepto2.default)(this).attr('payid');
        pay(payid);
    },
    'document|.pay_way ul li|click': function documentPay_wayUlLiClick() {
        if ((0, _zepto2.default)(this).hasClass('cho')) {
            return false;
        }
        (0, _zepto2.default)('.pay_way ul li').removeClass('cho');
        (0, _zepto2.default)(this).addClass('cho');
        shouleiPayType = (0, _zepto2.default)(this).attr('data-type');
        return false;
    },
    //刷新用户身份
    'document|.refreshInfo|click': function documentRefreshInfoClick() {
        refreshInfo();
    }
};
_util2.default.initEvents(Events);
module.exports = pay;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cover xl_wrap\" id=\"pay-pop\"><div class=\"xl_pop pop_type_1\" style=\"display:block\"><div class=\"xl_pop_t\"><h3>选择会员开通时长</h3></div><div class=\"xl_pop_m\"><div class=\"pay_form\"><ul id=\"month_list\" style=\"display: none;\"> {{for $d.listData}} <li class=\"{{$k == $d.monthinfo ? \'cho\': \'\'}}\" month=\"{{$v.month}}\" data-prize=\"{{$v.price}}\" data-oPrize=\"{{$v.org_price}}\"> <i class=\"ico_p_radio\"></i>{{ $v.other_name ? $v.other_name : $v.month+$v.monthunit}}{{ $v.tips}}</li> {{/for}}</ul><ul id=\"upgrade_list\" style=\"display: none;\"></ul><div class=\"pay_coupon\" id=\"cash_zone\" style=\"display: none;\"><input type=\"text\" class=\"ipt_cou\" placeholder=\"请选择代金券\" id=\"cash_input\" readonly=\"readonly\"><ul class=\"cou_list\" id=\"cash_list\"></ul><p class=\"cou_note\" id=\"cash_status\"></p></div><input type=\"text\" style=\"display:none\" id=\"po_cash\"><div class=\"pay_way\" style=\"display:{{ ($d.payway != \'jd\' && $d.alipayInstall && $d.weixinInstall) ? \'\' : \'none\' }}\"><h4>请选择支付方式</h4><ul><li class=\"cho\" data-type=\"1\"><i class=\"ico_p_radio\"></i><span class=\"ico_weixin\"></span>微信支付</li><li data-type=\"2\"><i class=\"ico_p_radio\"></i><span class=\"ico_zfb\"></span>支付宝支付</li></ul></div><p class=\"total_pri\">总金额：<span><span id=\"prize\">{{$d.listData[$d.monthinfo] && $d.listData[$d.monthinfo][\'price\']}}</span>元<span id=\"oPrize\" style=\"display:{{$d.listData[$d.monthinfo] && $d.listData[$d.monthinfo][\'org_price\']==\'\' ? \'none\' : \'\'}}\">(<b>原价<span id=\"oPrize_num\">{{$d.listData[$d.monthinfo] && $d.listData[$d.monthinfo][\'org_price\']}}</span>元</b>)</span></span></p></div></div><div class=\"xl_pop_b\"><a href=\"javascript:void(0)\" id=\"pay_btn\" class=\"btn_pay\" datatype=\"pay_click\" clickid=\"wap_pop_pay_button\" buttontype = \"pay_page_button\">立即支付</a></div><a href=\"javascript:msgExit()\" class=\"xl_pop_close\" title=\"关闭\">关闭</a></div></div>"

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// thunder.min.js